import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Assembly} from '../models';

@Injectable()
export class AssemblyService extends IoService{
  protected model = Assembly;
  protected listUrl = '/assemblies/';
}
